<template>
  <div v-if="dados" class="bg-white rounded px-4 pb-4">
    <div class="row">
      <div class="col-md-12 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label text-muted">Plano</div>
          <div class="text">{{ dados.dadosPlano.nome }}</div>
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Quantidade de CNPJ</div>
          <div class="text">{{ dados.dadosPlano.qtdCnpj }}</div>
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Quantidade Adquirentes</div>
          <div class="text">{{ dados.dadosPlano.qtdAdquirentes }}</div>
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Quantidade Transações</div>
          <div class="text">{{ dados.dadosPlano.qtdTransacoes }}</div>
        </div>
      </div>
      <div class="col-md-3 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Transações Excedentes</div>
          <div class="text">
            {{ dados.dadosPlano.transacoesExcedentes | currency }}
          </div>
        </div>
      </div>
      <div class="col-md-3 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Adquirentes Extras</div>
          <div class="text">
            {{ dados.dadosPlano.adquirenteExra | currency }}
          </div>
        </div>
      </div>
      <div class="col-md-3 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Custo Operadoras</div>
          <div class="text">{{ dados.dadosPlano.custoOperadoras }}</div>
        </div>
      </div>
      <div class="col-md-3 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Filial Extra</div>
          <div class="text">
            {{
              dados.dadosPlano.filialExtra ? dados.dadosPlano.filialExtra : "-"
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Adesão</div>
          <div class="text">{{ dados.dadosPlano.adesao | currency }}</div>
        </div>
      </div>
      <div class="col-md-6 mt-3">
        <div class="border px-2 pt-2 pb-1 rounded">
          <div class="label">Mensalidade</div>
          <div class="text">{{ dados.dadosPlano.mensalidade | currency }}</div>
        </div>
      </div>
    </div>
    <div class="border rounded mt-4 p-3 bg-light">
      <div class="h5 mb-0">Dados Adicionais</div>
      <div class="row">
        <div class="col-md-3 mt-3 text-left text-md-right">
          <div class="label">Quantidade de CNPJ Escolhido</div>
          <div class="text">
            {{ dados.qtdCnpj }}
          </div>
        </div>
        <div class="col-md-8 mt-3 text-left text-md-right">
          <div class="label">Operadoras Selecionadas</div>
          <div class="text">
            <span v-for="(operadora, index) in dados.operadoras" :key="index">
              {{ index == 0 ? operadora.name : "," + operadora.name }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DadosVidaResumo",
  props: ["dados"],
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  font-weight: 400;
  font-size: 0.9rem;
  margin-bottom: 5px;
  text-transform: uppercase;
}
.text {
  font-weight: bold;
  font-size: 1rem;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
  &.text-lg {
    font-size: 1.4rem;
  }
}
</style>
